import { JsonConverter, JsonObject, JsonProperty } from "ta-json";

import { AllFacetValuesChildrenConverter } from "../../converters/all-facet-values-children-converter";
import Resource from "../resource";
import { FacetResponseResource } from "./facet-response-resource";

export interface IAllFacetValuesResponse {
    query: string;
    facet: string;
    children: Record<string, Array<FacetResponseResource>>;
}

@JsonObject()
export class AllFacetValuesResponse extends Resource implements IAllFacetValuesResponse {
    @JsonProperty("query")
    query: string;

    @JsonProperty("facet")
    facet: string;

    @JsonProperty("children")
    @JsonConverter(AllFacetValuesChildrenConverter)
    children: Record<string, Array<FacetResponseResource>> = {};
}
